import { markSkipOnCompleteIfOnSuccessIsSet, replaceInChain } from "@insite/client-framework/HandlerCreator";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { chain, PopulateCart } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/UpdateCart";
import { StoreCartReducerState } from "@store/Store/Reducers/StoreCartReducer";
import StoreCartState from "@store/Store/Reducers/StoreCartState";

replaceInChain(chain, PopulateCart, props => {
    const state = props.getState();
    const { cartId, editedCartNotes, additionalEmails } = state.pages.checkoutShipping;
    const editedPoNumber = (props.getState() as any).storeCartReducer.editedPoNumber; // Valtech Custom Cote
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    if (!cart) {
        throw new Error("There was no current cart available while trying to update the current cart.");
    }

    const notes = typeof editedCartNotes === "undefined" ? cart.notes : editedCartNotes;
    const poNumber = typeof editedPoNumber === "undefined" ? cart.poNumber : editedPoNumber; // Valtech Custom Cote
    props.cart = {
        ...cart,
        notes,
        poNumber,
        additionalEmails: additionalEmails === undefined ? cart.additionalEmails : additionalEmails,
    };
});
